<template>
  <!-- 急救事例 -->
  <div class="basic-container container">
    <div class="basic-info-group basic-info-item ">
      <span class="basic-title">急救事例：</span>
      <div class="basic-info">
        <el-row class="info-row">
          <el-col :span="2" class="info-key">对象：</el-col>
          <el-col :span="5" class="info-item">
            {{ patient?.ambulance?.name + "-" + patient?.ambulance?.idName }}
          </el-col>
          <el-col :span="3" class="info-key">事例编号：</el-col>
          <el-col :span="2" class="info-item">{{ patient.number }}</el-col>
          <el-col :span="3" :offset="1" class="info-key">受理时间：</el-col>
          <el-col :span="4" class="info-item">{{ patient.formatTime }}</el-col>
        </el-row>
        <el-row class="info-row">
          <el-col :span="2" class="info-key">姓名：</el-col>
          <el-col :span="4" class="info-item">{{ patient.name }}</el-col>
          <el-col :span="2" class="info-key">年龄：</el-col>
          <el-col :span="3" :offset="1" class="info-item">{{ patient.age }}岁</el-col>
          <el-col :span="2" class="info-key">性别：</el-col>
          <el-col :span="2" class="info-item">{{ patient.gender }}</el-col>
          <el-col :span="3" class="info-key">联系电话：</el-col>
          <el-col :span="3" class="info-item">{{ patient.phoneNumber }}</el-col>
        </el-row>
        <el-row class="info-row">
          <el-col :span="2" class="info-key">住址：</el-col>
          <el-col
            :span="21"
            class="info-item"
          >{{ patient.patientAddr }}
          </el-col>
        </el-row>
        <el-row class="info-row">
          <el-col :span="2" class="info-key">主诉：</el-col>
          <el-col :span="21" class="info-item">{{ patient.mainComplaint }}</el-col>
        </el-row>
      </div>
    </div>

    <div class="connect-patient basic-info-item">
      <span class="basic-title">关联认证患者：</span>
      <div class="connect-info">
        <div v-if="isShowPatient">
          <div v-if="!isConnect" class="line"/>
          <el-row v-else class="history">
            <el-col :span="3" class="info-key">就诊史：</el-col>
            <el-col :span="20" :offset="1">
              <div v-for="(item, index) in history" :key="item.id">
                {{ index + 1 }}.{{ item.name }}——{{ item.method }}——{{ item.situation }}
              </div>
            </el-col>
          </el-row>
        </div>
        <div v-else class="basic-info">
          <el-row class="info-row">
            <el-col :span="3" class="info-key">身份证：</el-col>
            <el-col :span="3" :offset="1" class="info-key">
              <el-input v-model="IdCard"/>
            </el-col>
          </el-row>
          <connect-his/>
          <el-row v-if="isConnect" class="history">
            <el-col :span="3" class="info-key">就诊史：</el-col>
            <el-col :span="20" :offset="1">
              <div v-for="(item, index) in history" :key="item.id">
                {{ index + 1 }}. {{ item.name }}——{{ item.method }}——{{ item.situation }}
              </div>
            </el-col>
          </el-row>
          <el-button class="connect-button">{{ buttonText }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConnectHis from "./ConnectHIS";
import { mapState } from "vuex";

export default {
  name: "BasicInfo",
  components: {
    ConnectHis,
  },
  data() {
    return {
      type: "",
      IdCard: "",
      isConnect: false, // 是否关联
      history: [
        // {
        //   time: "2022-06-06 12:00",
        //   name: "疾病名称3",
        //   method: "采用的治疗方式",
        //   situation: "情况如下",
        //   id: 1
        // },
      ]
    };
  },
  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo"
    }),
    buttonText() {
      return this.isConnect ? "重新关联" : "关联";
    },
    isShowPatient() {
      return this.patient?.pageInfo?.isShowPatient;
    },
    isAddPatient() {
      return this.patient?.pageInfo?.isAddPatient;
    }
  },
};
</script>

<style lang="scss" scoped>
.basic-container {
  display: flex;
  background: #f0f5f7;
  padding: 0;
}

.basic-info-item {
  padding: 24px 36px;
  background-color: #ffffff;
  border-radius: 10px;
}

// 分区主体
.basic-info-group {
  flex: 1;
  min-width: 800px;
}

.basic-info {
  padding-top: 12px; // 分区信息标题(已经缩了12px了)
}

.connect-patient {
  width: 592px;
  margin-left: 36px;
  position: relative;
}

.connect-info ::v-deep {
  .connect-button {
    position: absolute;
    right: 36px;
    bottom: 16px;
    height: 32px;
    min-height: 32px;
    border: 1px solid #2AA5E3;
    border-radius: 10px;
    font-size: 16px;
    color: #2AA5E3;
    padding-top: 8px;
    padding-left: 16px;
  }

  .el-input__inner {
    width: 280px;
    height: 32px;
    border: 1px solid #999999;
    border-radius: 10px;
  }

  .line {
    width: 520px;
    height: 1px;
    background: #CCCCCC;
    position: absolute;
    top: 50%;
    //transform: translateX(-50%);
  }
}

.history {
  margin-top: 12px;

  > div {
    font-size: 16px;
    color: #333333;
    line-height: 28px;
  }
}
</style>
